//批量导出
import React, { useEffect, useState } from "react";
import { Modal, Progress, Button, message } from "antd";
import { fileDownloadApiNew } from "@/server";
import moment from "moment";
import common from "@/public/common";
const ExportShipping = (props) => {
  const { visible, selectedItems = [], onCancel } = props;
  const [progress, setProgress] = useState(0);
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    setProgress(0);
    setErrors([]);
    console.log(selectedItems);
  }, [visible]);

  const handleCancel = () => {
    onCancel();
  };

  const handleBatchCancel = async () => {
    try {
      const totalTasks = selectedItems.length;
      setProgress(0);
      setErrors([]);
      var errorsList = [];
      for (let i = 0; i < totalTasks; i++) {
        const { po_code } = selectedItems[i];
        try {
          const res = await fileDownloadApiNew({
            url: common.SapUrl + "/order/export-lens-template",
            param:{
              po_code
            },
            filename:
              "订货二维表" + moment(new Date()).format("YYYYMMDD") + ".xls",
          });
          setProgress((prevProgress) => prevProgress + 1);
          if (res.status != 200) {
            setErrors((prevErrors) => [
              ...prevErrors,
              {
                code: po_code,
                message: res.message || "请求失败",
              },
            ]);
            errorsList.push({
              code: po_code,
              message: res.message || "请求失败",
            });
          }
        } catch (error) {
          setProgress((prevProgress) => prevProgress + 1);
          setErrors((prevErrors) => [
            ...prevErrors,
            {
              code: po_code,
              message: error.message || "请求失败",
            },
          ]);
          errorsList.push({
            code: po_code,
            message: error.message || "请求失败",
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Modal
      destroyOnClose={true}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          关闭
        </Button>,
        <Button
          loading={progress > 0 && progress < selectedItems.length}
          key="submit"
          type="primary"
          onClick={handleBatchCancel}
        >
          开始导出
        </Button>,
      ]}
      title="批量导出镜片二维表"
    >
      <Progress percent={(progress / selectedItems.length) * 100} />
      {errors.length > 0 && (
        <div style={{ marginTop: 16, overflow: "auto", maxHeight: 400 }}>
          <h3>日志信息:</h3>
          <ul>
            {errors.map((e, index) => (
              <li key={index}>{`${e.code}：${e.message}`}</li>
            ))}
          </ul>
        </div>
      )}
    </Modal>
  );
};
export default ExportShipping;



// WEBPACK FOOTER //
// ./src/pages/orderAdmin/components/ExportShipping.jsx